module.exports = RedNaoFormBuilder.default('FormBuilder/Fields/Core/SubComponents/IconOrImageDisplayer');